import DeloitteMemberCard from './DeloitteMemberCard'

export default DeloitteMemberCard
